import { render, staticRenderFns } from "./CreateNewUserManagement.vue?vue&type=template&id=66a8c2a5&scoped=true&"
import script from "./CreateNewUserManagement.vue?vue&type=script&lang=js&"
export * from "./CreateNewUserManagement.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewUserManagement.vue?vue&type=style&index=0&id=66a8c2a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a8c2a5",
  null
  
)

export default component.exports